export default class ClickOutside {
	constructor(selector) {
		this.selector = selector
		this.$items = document.querySelectorAll(selector)

		if (this.$items.length) document.addEventListener('click', this.onDocumentClick)
	}

	onDocumentClick = (e) => {
		const clicked = e.target.closest(this.selector)

		this.$items.forEach(item => {
			// клик по самому элементу переключает его, клик мимо — закрывает все
			item === clicked ? item.classList.toggle('active') : item.classList.remove('active')
		})
	}
}
